import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { CACHE_KEY_ZIP_CODE_DELIVERABLE } from 'src/app/hooks/data/_keys';
import type { IsZipCodeDeliverable } from 'src/app/types/zipCode';

import { useBffClient } from './useBffClient';

export const useZipCodeDeliverabilityCheck = (
  zipCode: string,
  { enabled }: { enabled?: boolean }
): UseQueryResult<IsZipCodeDeliverable, AxiosError> => {
  const authClient = useBffClient();

  return useQuery(
    [CACHE_KEY_ZIP_CODE_DELIVERABLE, zipCode],
    () => authClient.get(`delivery_availability/zip_code/${zipCode}`).then(response => response.data),
    {
      ...(enabled !== undefined && { enabled }),
    }
  );
};
